import React from 'react';
import Icon from '../../../components/AppIcon';

const DepartmentBreakdownTable = ({ departmentData }) => {
  const getScoreColor = (score) => {
    if (score >= 90) return 'text-success';
    if (score >= 75) return 'text-warning';
    return 'text-error';
  };

  const getVarianceColor = (variance) => {
    if (variance > 0) return 'text-success';
    if (variance < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return typeof value === 'number' ? value?.toFixed(1) : value;
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Building2" size={20} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Department Breakdown
          </h3>
        </div>
        <p className="caption text-xs md:text-sm text-muted-foreground mt-1">
          Compliance performance by department
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left">
                <span className="caption text-xs font-medium text-foreground">Department</span>
              </th>
              <th className="px-4 py-3 text-center">
                <span className="caption text-xs font-medium text-foreground">Score</span>
              </th>
              <th className="px-4 py-3 text-center">
                <span className="caption text-xs font-medium text-foreground">Variance</span>
              </th>
              <th className="px-4 py-3 text-center hidden md:table-cell">
                <span className="caption text-xs font-medium text-foreground">Employees</span>
              </th>
              <th className="px-4 py-3 text-center hidden md:table-cell">
                <span className="caption text-xs font-medium text-foreground">Violations</span>
              </th>
              <th className="px-4 py-3 text-center hidden lg:table-cell">
                <span className="caption text-xs font-medium text-foreground">Payroll</span>
              </th>
              <th className="px-4 py-3 text-center hidden lg:table-cell">
                <span className="caption text-xs font-medium text-foreground">Leave</span>
              </th>
              <th className="px-4 py-3 text-center hidden lg:table-cell">
                <span className="caption text-xs font-medium text-foreground">Contracts</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {departmentData?.map((dept, index) => (
              <tr key={dept?.id || index} className="border-b border-border hover:bg-muted/50 transition-smooth">
                <td className="px-4 py-3">
                  <p className="caption text-sm font-medium text-foreground">{dept?.department}</p>
                </td>
                <td className="px-4 py-3 text-center">
                  <p className={`caption text-sm font-bold ${getScoreColor(dept?.complianceScore)}`}>
                    {formatValue(dept?.complianceScore)}%
                  </p>
                </td>
                <td className="px-4 py-3 text-center">
                  <p className={`caption text-sm font-medium ${getVarianceColor(dept?.variancePercentage)}`}>
                    {dept?.variancePercentage > 0 ? '+' : ''}{formatValue(dept?.variancePercentage)}%
                  </p>
                </td>
                <td className="px-4 py-3 text-center hidden md:table-cell">
                  <p className="caption text-sm text-foreground">{dept?.totalEmployees}</p>
                </td>
                <td className="px-4 py-3 text-center hidden md:table-cell">
                  <p className="caption text-sm text-foreground">
                    {dept?.violationsCount} <span className="text-error">({dept?.criticalViolations})</span>
                  </p>
                </td>
                <td className="px-4 py-3 text-center hidden lg:table-cell">
                  <p className={`caption text-sm ${getScoreColor(dept?.payrollAccuracy)}`}>
                    {formatValue(dept?.payrollAccuracy)}%
                  </p>
                </td>
                <td className="px-4 py-3 text-center hidden lg:table-cell">
                  <p className={`caption text-sm ${getScoreColor(dept?.leaveCompliance)}`}>
                    {formatValue(dept?.leaveCompliance)}%
                  </p>
                </td>
                <td className="px-4 py-3 text-center hidden lg:table-cell">
                  <p className={`caption text-sm ${getScoreColor(dept?.contractCompliance)}`}>
                    {formatValue(dept?.contractCompliance)}%
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {(!departmentData || departmentData?.length === 0) && (
        <div className="p-8 text-center">
          <Icon name="Building2" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3 opacity-50" />
          <p className="caption text-sm text-muted-foreground">No department breakdown data available</p>
        </div>
      )}
    </div>
  );
};

export default DepartmentBreakdownTable;